module.exports = __webpack_public_path__ + "img/logo.042bfd44.jpg";